import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, map } from 'lodash';
import { Link } from 'react-router-dom';

import { PATH } from '../../../../constants/path';
import { STATIC_ROOT } from '../../../../constants';
import { MOMENTJS_DATE_FORMAT } from '../../../../constants/moment';

import { fetchAccountMessagesIfNeeded } from '../../../../services/account/mymessages/actions';
import { fetchContactRequestReasonIfNeeded } from '../../../../services/contactrequest/actions';

import { toDate } from '../../../../utils/dateUtils';

import SvgComponent from '../../../SvgComponent';
import { HeadComponent } from '../../../HeadComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';

import './MyMessagesPage.scss';

const ICON_VALIDATED = 'valide';
const ICON_WAITING = 'attente';

const renderIcon = (icon, width, height) => (
    <SvgComponent src={`${STATIC_ROOT}/icon/${icon}.svg`} width={width} height={height} />
);

const renderMessageState = (icon, text, width, height) => (
    <div className="message-caption-block center-mobile">
        {renderIcon(icon, text, height, width)}
        <p className="hide-mobile">{text}</p>
    </div>
);

export class MyMessagesPage extends React.Component {
    renderConditionnalOnMessageState(state) {
        if (!state) return null;

        const { i18n } = this.props;
        if (state.id === 3) {
            return renderMessageState(ICON_VALIDATED, i18n.MESSAGES_CAPTION.DONE, 24, 24);
        } else {
            return renderMessageState(ICON_WAITING, i18n.MESSAGES_CAPTION.WAITING, 24, 25);
        }
    }

    renderConditionnalOnAnswerDate(answerDate) {
        if (!answerDate) return null;
        if (answerDate > 0) {
            return toDate(answerDate, MOMENTJS_DATE_FORMAT);
        }
    }

    renderContactRequestReasonLabel(id) {
        const { UNDEFINED } = this.props.common;
        const reason = this.props.contactrequestreasons.find(e => e.id === id);
        if (isEmpty(reason)) return UNDEFINED;
        return reason.label;
    }

    componentDidMount() {
        this.props.fetchContactRequestReasonIfNeeded();
        this.props.fetchAccountMessagesIfNeeded();
    }

    render() {
        const { i18n, data, fetching } = this.props;
        return (
            <div id="p-account-messages" className="container">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.ACCOUNT_MESSAGES_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h3>{i18n.PAGE_TITLE}</h3>
                <table>
                    <thead>
                        <tr>
                            <th>{i18n.MESSAGE_DATE}</th>
                            <th>{i18n.ANSWER_DATE}</th>
                            <th className="reason">{i18n.REQUEST_REASON}</th>
                            <th className="state">
                                <span className="hide-mobile">{i18n.REQUEST_STATE}</span>
                            </th>
                            <th className="hide-mobile">{i18n.DETAILS}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fetching ? (
                            <tr>
                                <td colSpan="5">
                                    <LoadingComponent />
                                </td>
                            </tr>
                        ) : (
                            map(data, message => (
                                <tr key={message.id}>
                                    <td>{toDate(message.requestDate, MOMENTJS_DATE_FORMAT)}</td>
                                    <td>
                                        {this.renderConditionnalOnAnswerDate(message.answerDate)}
                                    </td>
                                    <td>
                                        {this.renderContactRequestReasonLabel(
                                            message.contactRequestReasonId
                                        )}
                                    </td>
                                    <td className="picto">
                                        {this.renderConditionnalOnMessageState(message.state)}
                                    </td>
                                    <td className="hide-mobile">
                                        <Link to={`${PATH.ACCOUNT_MESSAGES_PATH}/${message.id}`}>
                                            {i18n.SHOW_MESSAGE_DETAILS}
                                        </Link>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                <section className="message-caption">
                    <div className="message-caption-block">
                        {renderIcon(ICON_VALIDATED, i18n.MESSAGES_CAPTION.DONE, 24, 24)}
                        <p>{i18n.MESSAGES_CAPTION.DONE}</p>
                    </div>
                    <div className="message-caption-block">
                        {renderIcon(ICON_WAITING, i18n.MESSAGES_CAPTION.WAITING, 24, 25)}
                        <p>{i18n.MESSAGES_CAPTION.WAITING}</p>
                    </div>
                </section>
                <section className="message-bottom">
                    {i18n.FOOTER_TEXT}
                    <Link to={PATH.FAQ_PATH}>FAQ</Link> ?
                    <Link to={PATH.CONTACTREQUEST_PATH}>{i18n.CONTACT_CUSTOMER_SERVICE}</Link>.
                </section>
            </div>
        );
    }
}

MyMessagesPage.propTypes = {
    common: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    data: PropTypes.array.isRequired,
    contactrequestreasons: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        common: state.i18n.common,
        i18n: state.i18n.page.ACCOUNT.MESSAGES,
        data: state.account.mymessages.messages || [],
        fetching: state.account.mymessages.fetching,
        contactrequestreasons: state.contactrequest
            ? state.contactrequest.contactrequestreasons
            : []
    };
}

const mapDispatchToProps = {
    fetchContactRequestReasonIfNeeded,
    fetchAccountMessagesIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(MyMessagesPage);



// WEBPACK FOOTER //
// ./src/components/pages/account/mymessages/MyMessagesPage.js